import {
  Add,
  Clear,
  Close,
  Done,
  Handyman,
  Info,
  Refresh,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { ChangeEvent, DragEvent, useState } from "react";
import { toast } from "react-toastify";
import FileDrop from "shared-component/file-upload";
import HeadersStats from "./component/HeaderStats";
import Papa from "papaparse";
import MsgReader from '@kenjiuno/msgreader';
import { decompressRTF } from '@kenjiuno/decompressrtf';
import iconv from 'iconv-lite';
import { Buffer } from 'buffer';
//import { useNavigate } from "react-router";
import { JobAuditTable } from "./component/JobAuditTable/JobAuditTable";
import { jobAuditSubTableHeader, jobAuditTableHeader } from "utility/constants";
import { useStyles } from '../cdad-header-revised/style';
import CloseIcon from '@mui/icons-material/Close';
import MaxToolTip from "shared-component/tooltip-max/toolTipMax";
import { WelcomeToolTipContent } from "pages/data-fill/components/FillToolTipContent";
import { useNavigate } from "react-router-dom";
import { linkCdadFilterAttributes, linkCdadFilterAttributes51F, linkCdadFilterAttributesCan, linkCdadFilterAttributesVins, cDadUnNestedData } from "assets/DataFile/headerPageData";

dayjs.extend(utc);
dayjs.extend(timezone);

const TCIDRegex = /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/;

const CDad = () => {
  const style = useStyles();
  const theme = useTheme();
  const [showAddRequest, setShowAddRequest] = useState<boolean>(false);
  const [jobName, setJobName] = useState<string>("");
  const [url, seturl] = useState<string>("");
  const [urlList, setUrlList] = useState<string[]>([]);
  const [underDev] = useState<boolean>(false);
  const [headerStatsPopup, setHeaderStatsPopup] = useState<Object | null>(null);
  const [inputType, setInputType] = useState<"s3" | "csv" | "eml">("s3");
  const navigate = useNavigate();
  const [tcIdList, settcIdList] = useState<string[]>([]);
  const [tcIdListMsg, settcIdListMsg] = useState<string[]>([]);
  const [, setParams] = useState<any>();
  //const navigate = useNavigate();

  const StyledLinkText = styled(TableRow)(({ theme }) => ({
    color: "#42A5F5",
  }));
  const handleAddNewURL = () => {
    if (url) {
      setUrlList((prev) => [...prev, `${url}`]);
    }
    seturl("");
  };
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [, setHeaderJobId] = useState<string>('');
  // const handleChange = (event: any) => {
  //   setBucket(event.target.value as string);
  // };

  const getCanList = () => {
console.log('logged')
  };

  async function parseMsgFileAsync(
    file: File,
    onSetRtf: (rtf: string) => void,
  ) {
    const msgRead = new MsgReader(await file.arrayBuffer());
    const { compressedRtf } = msgRead.getFileData();
    if (compressedRtf) {
      const rtfBlob = decompressRTF(Array.from(compressedRtf));
      onSetRtf(
        iconv.decode(
          Buffer.from(rtfBlob),
          "latin1"
        )
      );
    }
    else {
      onSetRtf("");
    }
  }
  const getMsgData = (msgFile: any) => {
    let tcID: any = [];
    Array.from(msgFile)?.forEach((item: any) => {
      parseMsgFileAsync(
        item,
        rtfText => {
          if (rtfText.length !== 0) {
            try {
              const test: any = /&prefix=([^&\s]+)/g;
              let match: any = rtfText.match(test);
              match.forEach((item: any) => {
                if (item?.indexOf('&prefix') >= 0) {
                  tcID.push(item?.split('&prefix=')[1]?.split('*')[0])
                }
              })
            }
            catch (error) {
              console.log('error:', error)
            }
          }
        }
      );
    })
    settcIdListMsg(tcID)
  }


  const getTcIdFromCsv = (sFiles: any) => {
    let tcIdLists: Array<string> = [];
    Array.from(sFiles)?.forEach((item: any) => {
      Papa.parse(item, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          const dataCsv = results.data;
          dataCsv?.forEach((item: any) => {
            if (item.TCID?.length > 0) {
              tcIdLists?.push(item?.TCID)
            }
          })
        },
      });
    })
    return settcIdList(tcIdLists)
  }

  const handleCsvFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const sFiles = event.target.files;

    // Check if files are PDFs (optional)
    if (sFiles && sFiles.length > 0) {
      getTcIdFromCsv(sFiles);
      const previouseFiles: any = [];
      Array.from(sFiles).forEach((file: File, index: number) => {
        if (file?.type === "text/csv" && !previouseFiles?.includes(file.name)) {
          console.log('testeer')
        } else {
          toast.warning("Please select CSV files only!");
        }
      });
    }
  };

  const handleCsvDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // Fetch the files
    const sFiles = Array.from(event.dataTransfer.files);

    // Check if files are PDFs (optional)
    if (sFiles && sFiles.length > 0) {
      getTcIdFromCsv(sFiles);
      const previouseFiles: any = [];
      Array.from(sFiles).forEach((file: File, index: number) => {
        if (file?.type === "text/csv" && !previouseFiles?.includes(file.name)) {
          console.log('data')
        } else {
          toast.warning("Please select CSV files only!");
        }
      });
    }
  };

  const getEmlData = (filess: any) => {
    let tcIDEML: any = [];
    Array.from(filess)?.forEach((item: any) => {
      item.arrayBuffer().then(async (data: any) => {
        try {
          const emlr = await import('../../utility/emlReader');
          let test = new emlr.EmlReader(data);
          const tess = test.getMessageText();
          const testReg: any = /&prefix=([^&\s]+)/g;
          let match: any = tess.match(testReg);
          match.forEach((item: any) => {
            if (item?.indexOf('&prefix') >= 0) {
              tcIDEML.push(item?.split('&prefix=')[1]?.split('*')[0])
            }
          })
        } catch (e) {
          console.error(e);
        }
      });
    });
    settcIdListMsg(tcIDEML)
  }

  const handleEmlFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const sFiles = event.target.files;
    // Check if files are PDFs (optional)
    if (sFiles && sFiles.length > 0) {
      if (sFiles[0]?.name.indexOf('.eml') > 0) {
        getEmlData(sFiles)
      } else {
        getMsgData(sFiles)
      }
      const previouseFiles: any = [];
      Array.from(sFiles).forEach((file: File, index: number) => {
        if (
          (file.type === "message/rfc822" ||
            file.name.split(".").pop() === "msg") &&
          !previouseFiles?.includes(file.name)
        ) {
          console.log('data')
        } else {
          toast.warning("Please select .eml or .msg files only!");
        }
      });
    }
  };

  const handleEmlDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // Fetch the files
    const sFiles = Array.from(event.dataTransfer.files);

    // Check if files are PDFs (optional)
    if (sFiles && sFiles.length > 0) {
      if (sFiles[0]?.name.indexOf('.eml') > 0) {
        getEmlData(sFiles[0])
      } else {
        getMsgData(sFiles[0])
      }
      const previouseFiles: any = [];
      Array.from(sFiles).forEach((file: File, index: number) => {
        if (
          (file.type === "message/rfc822" ||
            file.name.split(".").pop() === "msg") &&
          !previouseFiles?.includes(file.name)
        ) {
          console.log('data')
        } else {
          toast.warning("Please select .eml or .msg files only!");
        }
      });
    }
  };


  const handleRequestHeader = async () => {
    setShowAddRequest(false);
    const formData = new FormData();
    if (inputType === "csv") {
      [].forEach((file: any) => {
        formData.append(file.id, file.doc);
      });
    } else if (inputType === "eml") {
      [].forEach((file: any) => {
        formData.append(file.id, file.doc);
      });
    }
    // formData.append()
    if (inputType === "s3") {
      const payload = {
        inputType: inputType,
        jobName: jobName,
        userInput: urlList,
      };
    console.log('payload', payload)

    } else if (inputType === "csv") {
      const payload = {
        inputType: inputType,
        jobName: jobName,
        userInput: tcIdList,
      };
    console.log('payload', payload)

    } else if (inputType === "eml") {
      const payload = {
        inputType: inputType,
        jobName: jobName,
        userInput: tcIdListMsg,
      };
    console.log('payload', payload)

    }
    autoRefresHJobAudit();
  };

  const autoRefresHJobAudit = () => {
    setTimeout(() => {
      getCanList()
    }, 30000)
  }

  const handleHeaderDataClick = async (params: any) => {
    if (params?.status === "Success") {
      setParams(params)
      navigate("/headers-data", {state: {id: params?.id, jobName: params?.job_name, linkCdadFilterAttributesData: linkCdadFilterAttributes, linkCdadFilterAttributesDataVins: linkCdadFilterAttributesVins, linkCdadFilterAttributesData51F: linkCdadFilterAttributes51F, linkCdadFilterAttributesDataCan: linkCdadFilterAttributesCan}})
    }
  };

  const handleRawDataClick = async (param: any, headerJobId: string) => {
    if (param?.status === "Success") {
      setParams(param)
      setHeaderJobId(headerJobId)
      console.log('raw data click', param, cDadUnNestedData)
      navigate("/raw-data", { state: { id: param?.id, jobName: param?.job_name, cDadUnNestedDataValue: {data: cDadUnNestedData}, pageNo: 1, userInput: param?.user_inputs, subJobs: param?.subJobs, headerJobId: headerJobId } });
    }
  }
  

  const downloadCSVSample = () => {
    const blob = new Blob(["TCID"], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', 'sampleVinFile.csv');
    a.click()
  }

  return (
    <Box height={"100%"}>
      {underDev ? (
        <Box
          display={"flex"}
          height={"100%"}
          flexDirection={"column"}
          borderRadius={5}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ backgroundColor: theme.palette.text.disabled }}
        >
          <Handyman
            sx={{ fontSize: "100px", color: theme.palette.text.primary }}
          />
          <Typography
            variant="h4"
            fontWeight={"bold"}
            color={theme.palette.text.primary}
          >
            Under Development
          </Typography>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              display: {
                md: "flex",
                sm: "flex",
                xs: "none",
              },
            }}
              alignItems={"center"}
              gap={1}
            >
              <Box flex={1}>
                <Typography
                  pt={1}
                  variant="h5"
                  color={theme.palette.primary.contrastText}
                >
                  {"Connected Vehicles - Data Analytics Dashboard"}
                  <MaxToolTip infoIconColor content={WelcomeToolTipContent} />
                </Typography>
              </Box>

              <Tooltip title="Submit a request to unnest the data">
                <Button
                  startIcon={<Add />}
                  color="primary"
                  onClick={() => {
                    setShowAddRequest(true);
                    setUrlList([]);
                    seturl("");
                    setJobName("");
                  setInputType("s3");
                }}
                sx={{
                  borderRadius: 50,
                  px: 2,
                  backgroundColor: theme.palette.primary.contrastText,
                  "&:hover": {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.primary.contrastText,
                  },
                }}
              >
                Add
              </Button>
            </Tooltip>
            <Button
              startIcon={<Refresh />}
              onClick={getCanList}
              color="primary"
              sx={{
                borderRadius: 50,
                px: 2,
                backgroundColor: theme.palette.primary.contrastText,
                "&:hover": {
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.primary.contrastText,
                },
              }}
            >
              Refresh
            </Button>
          </Box>
          <Paper
            elevation={2}
            sx={{
              marginTop: "20px",
              marginBottom: "20px",
              padding: 1,
            }}
          >
         
            {false ?
              <div className={style.overlay}>
                <div className={style.loader}></div>
              </div> :
              <JobAuditTable headData={jobAuditTableHeader} subHeadData={jobAuditSubTableHeader} auditList={{}} handleHeaderDataClick={handleHeaderDataClick} handleRawDataClick={handleRawDataClick} />}
          </Paper>
        </Box>
      )}
      <Dialog
        open={showAddRequest}
        fullWidth
        onClose={() => setShowAddRequest(false)}
      // sx={{ width: "50vw",border: "2px solid" }}
      >
        <DialogTitle>
          <Typography fontWeight={"bold"} color={"primary"}>
            Header Stats Request
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setShowAddRequest(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Accordion>
            <AccordionSummary>
              <Typography variant="body1" fontWeight={"bold"} flexGrow={1}>
                Data Processing Time
              </Typography>
              <Info color="info" />
            </AccordionSummary>
            <AccordionDetails>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding={"none"} sx={{ fontWeight: "bold" }}>
                      Data Request Range
                    </TableCell>
                    <TableCell padding={"none"} sx={{ fontWeight: "bold" }}>
                      Data Size
                    </TableCell>
                    <TableCell padding={"none"} sx={{ fontWeight: "bold" }}>
                      Estimated time of completion
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell padding={"none"}>3 months</TableCell>
                    <TableCell padding={"none"}>997 MB</TableCell>
                    <TableCell padding={"none"}>10 mins</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding={"none"}>6 months</TableCell>
                    <TableCell padding={"none"}>2.2 GB</TableCell>
                    <TableCell padding={"none"}>13 mins</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding={"none"}>12 months</TableCell>
                    <TableCell padding={"none"}>2.4 GB</TableCell>
                    <TableCell padding={"none"}>17 mins</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>

          <TextField
            variant="outlined"
            label={"Job Name"}
            placeholder={"Job Name"}
            onChange={(e) => {
              setJobName(e.target.value?.trim());
            }}
            required
            value={jobName}
            fullWidth
            size={"small"}
            sx={{ mt: 2 }}
          />

          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <RadioGroup
              row
              sx={{ pt: 1 }}
              value={inputType}
              onChange={(e) => {
                setInputType(e.target.value as "s3" | "csv" | "eml");
                if (e.target.value === "manual") {
                  setUrlList([]);
                } else if (e.target.value === "csvUpload") {
                  console.log('test')
                } else if (e.target.value === "emlUpload") {
                  console.log('test')
                }
              }}
            >
              <FormControlLabel value="s3" control={<Radio />} label="Manual" />
              <FormControlLabel
                value="csv"
                control={<Radio />}
                label="CSV Import"
              />
              <FormControlLabel
                value="eml"
                control={<Radio />}
                label="Email Import"
              />
            </RadioGroup>
          </Box>
          {inputType === "s3" ? (
            <Box>
              <Box display={"flex"} gap={0.5} pt={2}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    label={"TC ID"}
                    placeholder={"TC ID"}
                    onChange={(e) => {
                      const value = e.target.value
                      const regex = /^[0-9a-zA-Z-]+$/; //regex for alpha numeric and - symbol
                    if (value.match(regex) || value === "") {
                      seturl(value?.trim());
                    }
                    }}
                    required
                    onKeyDown={(ev) => {
                      if (ev.key === "Enter" && TCIDRegex.test(url)) {
                        ev.preventDefault();
                        handleAddNewURL();
                      }
                    }}
                    value={url}
                    fullWidth
                    size={"small"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Add the URL to the list">
                            <IconButton
                              color="success"
                              disabled={!TCIDRegex.test(url)}
                              onClick={() => {
                                handleAddNewURL();
                              }}
                              edge="end"
                              size="small"
                            >
                              {<Done />}
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Clear text field">
                            <IconButton
                              color="error"
                              onClick={(e) => {
                                seturl("");
                              }}
                              edge="end"
                              size="small"
                            >
                              {<Clear />}
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              {urlList
                ? urlList.map((u, i) => {
                  const k = `${u}-${i}`;
                  return (
                    <Box
                      key={k}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography variant="body2" flex={1}>
                        {u}
                      </Typography>
                      <IconButton
                        color="error"
                        onClick={() =>
                          setUrlList((prev) => prev.filter((l) => l !== u))
                        }
                        edge="end"
                      >
                        <Clear />
                      </IconButton>
                    </Box>
                  );
                })
                : null}
            </Box>
          ) : null}

          {/* <Divider sx={{ py: 1 }}>
            <Typography color={theme.palette.text.disabled} fontWeight={"bold"}>
              OR
            </Typography>
          </Divider> */}

          {inputType === "csv" ? (
            <Box>
              <FileDrop
                handleDrop={handleCsvDrop}
                handleClick={handleCsvFileChange}
                label={"Drag and drop or click to add .csv files"}
                accept={".csv"}
              />
              {true
                ? [].map((u: any) => {
                  return (
                    <Box
                      key={u.id}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography variant="body2" flex={1}>
                        {u.doc.name}
                      </Typography>
                      <IconButton
                        color="error"
                        onClick={() => {
                          console.log('test')
                        }}
                        edge="end"
                      >
                        <Clear />
                      </IconButton>
                    </Box>
                  );
                })
                : null}
              <div className='sampleDoc' style={{ paddingTop: '16px' }}>
                <Link
                  component="button"
                  underline="none"
                  variant="body1"
                  onClick={() => {
                    downloadCSVSample()
                  }}
                >
                  <StyledLinkText>{'Download Sample TCID Template'}</StyledLinkText>
                </Link>
              </div>
            </Box>
          ) : null}

          {inputType === "eml" ? (
            <Box>
              <FileDrop
                handleDrop={handleEmlDrop}
                handleClick={handleEmlFileChange}
                label={"Drag and drop or click to add .eml or .msg files"}
                accept={".eml, .msg"}
              />
              {true
                ? [].map((u: any) => {
                  return (
                    <Box
                      key={u.id}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography variant="body2" flex={1}>
                        {u.doc.name}
                      </Typography>
                      <IconButton
                        color="error"
                        onClick={() => {
                          console.log('test')
                        }}
                        edge="end"
                      >
                        <Clear />
                      </IconButton>
                    </Box>
                  );
                })
                : null}
            </Box>
          ) : null}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <LoadingButton
            loadingPosition="center"
            variant="contained"
            disabled={
              (((inputType === "s3" && urlList.length === 0) || jobName?.length === 0) ||
                ((inputType === "csv" && [].length === 0) || jobName?.length === 0) ||
                ((inputType === "eml" && [].length === 0) || jobName?.length === 0))
            }
            onClick={handleRequestHeader}
            sx={{ borderRadius: 50 }}
          >
            Request Header stats
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Typography fontWeight={'bold'}>NO DATA AVAILABLE</Typography>
          <IconButton
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            onClick={() => setModalOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
            <Typography>No Data is Available for this Job, Please recreate another prepared job.</Typography>
        </DialogContent>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-around"}
          alignItems={"center"}
          padding={'2%'}
        >
          <Button variant='contained' style={{ width: '25%' }} onClick={() => setModalOpen(false)}>CLOSE</Button>
        </Box>
      </Dialog>
      <HeadersStats
        open={headerStatsPopup !== null}
        onClose={() => setHeaderStatsPopup(null)}
        job={headerStatsPopup ?? {}}
      />
    </Box>
  );
};

export default CDad;
